import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

const LOCATION = 'scheduling_page'

const BANNER_PROPERTIES = {
  cta_key: 'email_agent_banner',
  location: LOCATION
}

export const bannerShownEvent = {
  name: TRACKING_EVENT_NAMES.CTA_SHOWN,
  properties: {
    ...BANNER_PROPERTIES,
    cta_text: 'email_agent_banner_shown'
  }
}

export const trackTryItOutClicked = (track) => track({
  name: TRACKING_EVENT_NAMES.CTA_CLICKED,
  properties: {
    cta_key: 'scheduling_page_banner',
    cta_text: 'get_started',
    cta_details: 'try_email_agent',
    location: LOCATION
  }
})

export const trackTrySchedulingWithAiClicked = (track) => track({
  name: TRACKING_EVENT_NAMES.CTA_CLICKED,
  properties: {
    cta_key: 'scheduling_page',
    cta_text: 'try_scheduling_with_ai',
    cta_details: 'try_email_agent',
    location: LOCATION
  }
})

export const trackDismissed = (track) => track({
  name: TRACKING_EVENT_NAMES.CTA_CLICKED,
  properties: {
    ...BANNER_PROPERTIES,
    cta_text: 'email_agent_banner_dismissed',
    action: 'dismissed'
  }
})
